module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Курсы валют":"Currency rates","Я продаю":"I\u0027m selling","Я покупаю":"I\u0027m buying","Фиат":"Fiat","Криптовалюты":"Crypto","Обновление":"Updating","Обменять валюту":"Currency exchange"}}')
  delete Component.options._Ctor
}
